export const ISSUES_ENDPOINT_KEY = 'issues'
